import { NgClass } from '@angular/common';
import { Component, computed, input, model, OnInit, signal, Signal } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

import { Company } from '@app/shared/types/models/company/company.model';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { ProffeoUiInputValue } from '@app/shared/ui/types/input.types';

@Component({
  selector: 'proffeo-select-company-list',
  imports: [MatRadioModule, UiInputComponent, NgClass],
  templateUrl: './select-company-list.component.html'
})
export class SelectCompanyListComponent implements OnInit {
  protected readonly search = signal<ProffeoUiInputValue>('');
  protected readonly filteredCompanies = computed((): Company[] => {
    const companies = this.companies()?.() ?? [];
    const searchValue = String(this.search() ?? '')
      .toLowerCase()
      .trim();
    return searchValue
      ? companies.filter(company => (company.name ?? '').toLowerCase().includes(searchValue))
      : companies;
  });

  public readonly companies = input.required<Signal<Company[]>>();
  public readonly preselectedCompanyId = input<string | undefined>(undefined);
  public readonly selectedCompanyId = model<string | undefined>();

  public ngOnInit(): void {
    const preselected = this.preselectedCompanyId();
    if (preselected !== undefined && this.selectedCompanyId() === undefined) {
      this.selectedCompanyId.set(preselected);
    }
  }

  protected selectCompany(company: Company): void {
    this.selectedCompanyId.set(company.id);
  }
}
